	// Updates the selection value for a multiple selection item.  Currently maintains values in HTML to be compatible with other action functions
	// Parameters: Action_Namespace, Input_Namespace, Input_Alias, Item (by ID), Item_Type, Value

// TODO - don't know if we still use "Selectors" or "Count".
// TODO - Difference Mode Guide

// Value: True
	// Difference Mode
		// If it exists, and is true - throw error
		// If it exists, and is false - destroy it
	// Normal Mode
		// If doesn't exist -  create it

// Value: False
	// Difference Mode
		// If it doesn't exist, create it
		// If it exists, and is true - throw error
	// Normal Mode
		// If it exists, and is true, destroy it
		// If it exists, and is false, throw an error

Jelly.Actions.Update_Selection = function(Parameters) {

	var Debug = true && Jelly.Debug.Debug_Mode;
	
	if (Debug) {
		Jelly.Debug.Group("Update Selection");
		Jelly.Debug.Log(Parameters);
	}
		
	// Get values wrapper. 
	var Values_Wrapper =  $("#" + Parameters["Input_Namespace"] + "_Value_Input_Finder");
		
	// If the value is +, add the input if it doesn't exist.
	var Value_Name = Parameters["Input_Alias"] + "_" + Parameters["Item_Type"] + "_" + Parameters["Item"];	
	var Value_ID = Parameters["Action_Namespace"] +"_Input_" + Value_Name;

	// Get possible value input
	var $Value_Input = Values_Wrapper.find("#" + Value_ID);

	// TODO - convert to Jelly.Actions.Add_Hidden_Value
	var Action = "";

	// If it's true
	if (Parameters["Value"]) {

		// In persistent mode
		if (Parameters["Difference_Mode"]) {
			
			// If it exists
			if ($Value_Input.length) {

				// If it's true, throw error
				if ($Value_Input.val().toLowerCase() == "true") {
					alert("Bug 1");
				}
				// If it's false, destroy it
				else { 
					Action = "Remove";
				}
			}
		}

		// If not in persistent mode
		else { 

			// If it exists and it's false, throw an error
			if ($Value_Input.length) {
				if ($Value_Input.val().toLowerCase() != "true") {
					alert("Bug 2");
				}
			}
			// If it doesn't exist, create it
			else {
				Action = "Create";
			}
		}
	}
	// If we're setting something to false
	else { 

		// If in persistent mode	
		if (Parameters["Difference_Mode"]) {
			if ($Value_Input.length) {

				// If it exists and is true, throw an error
				if ($Value_Input.val().toLowerCase() == "true") { 
					alert("Bug 3");
				}
			}

			// If it doesn't exist, create it
			else {
				Action = "Create"
			}
		}
		// If not in persistent mode	
		else { 
			if ($Value_Input.length) {	
				// If it's true, destroy it
				if ($Value_Input.val().toLowerCase() == "true") { 
					Action = "Remove"
				}
				// If it's false, throw an error
				else { 
					alert("Bug 4");	
				}
			}
		}
	}

	switch (Action) { 

		case "Create":
			$Value_Input = $('<input/>', { 
				class: "Value",
				type: 'hidden',
				id: Value_ID,
				name: Value_Name
			})
				.attr("data-id",  Parameters["Item"]);

			// Add it to DOM
			Values_Wrapper.append($Value_Input);
			
			// Register input to the action namespace.
			Jelly.Actions.Register_Action_Input({
				Namespace: Parameters["Action_Namespace"],
				Element: $Value_Input.get(0)
			});
			$Value_Input.val(Parameters["Value"]);
			break;

		case "Remove":
			// Remove value
			Jelly.Actions.Remove_Action_Input({
				Namespace: Parameters["Action_Namespace"],
				Element: $Value_Input.get(0)
			});
			break;
		default:
			break;
	}

	// Handle selectors
	// TODO - Don't know much about what this was, but I think for AI data
	if (Parameters["Value"]) {
		// If selectors are supplied, create inputs for those too.
		if (Parameters["Selector_Property"]) { 
			// Create selector property input
			var Selector_Property_Input = $('<input/>', { 
				class: "Selector_Property",
				type: 'hidden',
				id: Value_ID + "_Selector_Property",
				name: Value_Name + "_Selector_Property"
			})
				.val(Parameters["Selector_Property"]);
			
			// Add it to DOM
			Values_Wrapper.append(Selector_Property_Input);
			
			// Register input to the action namespace.
			Jelly.Actions.Register_Action_Input({
				Namespace: Parameters["Action_Namespace"],
				Element: Selector_Property_Input.get(0)
			});

			// Create selector value input
			var Selector_Value_Input = $('<input/>', { 
				class: "Selector_Value",
				type: 'hidden',
				id: Value_ID + "_Selector_Value",
				name: Value_Name + "_Selector_Value"
			})
				.val(Parameters["Selector_Value"]);
			
			// Add it to DOM
			Values_Wrapper.append(Selector_Value_Input);
			
			// Register input to the action namespace.
			Jelly.Actions.Register_Action_Input({
				Namespace: Parameters["Action_Namespace"],
				Element: Selector_Value_Input.get(0)
			});
		}
	}
	else {
		// Remove selectors if they exist
		if (Values_Wrapper.find("#" + Value_ID + "_Selector_Property").length) {
			Jelly.Actions.Remove_Action_Input({
				Namespace: Parameters["Action_Namespace"],
				Element: Values_Wrapper.find("#" + Value_ID + "_Selector_Property").get(0)
			});
		}
		if (Values_Wrapper.find("#" + Value_ID + "_Selector_Value").length) {
			Jelly.Actions.Remove_Action_Input({
				Namespace: Parameters["Action_Namespace"],
				Element: Values_Wrapper.find("#" + Value_ID + "_Selector_Value").get(0)
			});
		}		
	}
	
	// Update value count 

	// Get the current count 
	var Selected_Values_Count = Values_Wrapper.find("input.Value").length;

	if (Selected_Values_Count) {
		// Show counter
		Jelly.jQuery("#" + Parameters["Input_Namespace"] + "_Select_Counter").show();
	
		// Update counter value
		Jelly.jQuery("#" + Parameters["Input_Namespace"] + "_Select_Counter .Count").html(Selected_Values_Count);
	
		// Show single or plural
		if (Selected_Values_Count == 1) {
			Jelly.jQuery("#" + Parameters["Input_Namespace"] + "_Select_Counter .Single").show();
			Jelly.jQuery("#" + Parameters["Input_Namespace"] + "_Select_Counter .Plural").hide();
		}
		
		// TODO -  Lol I guess this works
		else if (Selected_Values_Count == 2) {
			Jelly.jQuery("#" + Parameters["Input_Namespace"] + "_Select_Counter .Single").hide();
			Jelly.jQuery("#" + Parameters["Input_Namespace"] + "_Select_Counter .Plural").show();							
		}
	}
	
	// Otherwise hide counter
	else {
		Jelly.jQuery("#" + Parameters["Input_Namespace"] + "_Select_Counter").hide();
	}
	
	if (Debug) {
		Jelly.Debug.End_Group("");
	}
};